import { render, staticRenderFns } from "./TableDropdownV2.vue?vue&type=template&id=0834d964&scoped=true&"
import script from "./TableDropdownV2.vue?vue&type=script&lang=js&"
export * from "./TableDropdownV2.vue?vue&type=script&lang=js&"
import style0 from "./TableDropdownV2.vue?vue&type=style&index=0&id=0834d964&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0834d964",
  null
  
)

export default component.exports